// const baseUrl = "http://192.168.168.57:8080/blogfortis/api/";
const baseUrl = "https://api.blogfortis.com/api/";

const BaseUrl={
    baseUrl
};

export default BaseUrl;